



























































































































































import { Component, Watch, Mixins, Prop } from "vue-property-decorator";
import { quillEditor } from "vue-quill-editor";
// require styles 富文本编辑器对应的样式
import "quill/dist/quill.core.css";
import "./quill.snow.css";
import { IArticle } from "@/common/entity/Article";
import {
  ActionType,
  CountResultTip,
  CalculateStatus,
  correctionMarkId,
  ICorrectInfo,
  Contents,
} from "./CheckPage";
import { CorrectStatus } from "@/common/entity/Correction";
import {
  ChangeSource,
  EventName,
  QuillEditor,
} from "@/common/entity/QuillEditor";
import { appColors, qEditorDefaultOptions } from "@/common/AppConst";
import { RootGetterNames, RootMutationNames, RootState } from "@/vuex-store";
import { COUNT_NO_LIMIT, IUser, User } from "@/common/entity/User";
import { Getter } from "vuex-class";
import { logError, logToConsole, logToServer } from "@/common/LogHelper";
import CountTextLenMixin from "./CountTextLenMixin";
import CorrectMarkMixin from "./CorrectMarkMixin";
import {
  htmlStartWithWrap,
  htmlTextSplitLines,
  isEmpty,
} from "@/common/StringHelper";
import { Message } from "element-ui";
import { CorrectOpType } from "@/common/entity/CorrectResult";
import { doCorrection } from "@/common/CorrectHelper";
import {
  ArticleApis,
  CorrectionRespData,
  CorrectParams,
  CorrectRespData,
  LongCorrectRespData,
} from "@/request/article";
import { PageParamsMap, RouterTools } from "@/common/RouterTools";
import { Response } from "@/common/entity/Response";
import { debounce } from "vue-debounce";

@Component<Check>({
  components: {
    quillEditor,
  },
  /** 路由离开时调用 */
  async beforeRouteLeave(to, _, next) {
    // 保存之后的跳转指定文章界面时
    if (to.params.afterSaved) {
      next();
      return;
    }

    // 如果需要，提醒用户是否保存文章
    try {
      await this.showConfirmSave();
      // 不保存、不需要保存或保存成功继续跳转
      next();
    } catch (error) {
      logError(error);
      // 取消离开或保存失败，中断跳转
      next(false);
    }
  },
})
export default class Check extends Mixins(CountTextLenMixin, CorrectMarkMixin) {
  /**
   * 当前操作类型，创建文章、查看范文或查看文章
   */
  @Prop(Number) readonly actionType!: ActionType;
  /**
   * 编辑器配置
   */
  readonly qEditorOptions = {
    ...qEditorDefaultOptions,
    placeholder: "请输入文章内容...",
  };
  readonly CorrectOpType = CorrectOpType;

  /**
   * 显示多篇文章模式下的文章map，key为文章id，
   * value为文章实例本身
   */
  articleMap: { [key: number]: IArticle } = {};
  /**
   * 保存成功后的文章
   */
  savedArticle: IArticle | null = null;
  /**
   * 标题输入框内容
   */
  currTitle: string = "";
  /**
   * 当前是否是长文本模式
   */
  isLongTextModel: boolean = false;
  /**
   * 计算纠错次数后，内容是否已经更改
   */
  isUpdateSinceCalculate: boolean = false;
  /**
   * 导致计算纠错次数失败的文本，一般是"单句"文本过长时的"单句“文本
   */
  failText: string | null = null;
  /**
   * 是否正在纠错中
   */
  correcting: boolean = false;
  /** “返回编辑”按钮要返回的文章ID */
  fromArticleId: number | null = null;

  /**
   * 当前是否已经是登录状态
   */
  @Getter(RootGetterNames.isLogined)
  isLogined!: boolean;

  /** 文章标题前的 label */
  get titleLabel(): string {
    switch (this.actionType) {
      case ActionType.example:
        return "范文标题：";
      case ActionType.edit:
        return this.canSave ? "编辑文章：" : "查看文章：";
      case ActionType.create:
        return "创建文章：";
    }
  }

  /**
   * 是否显示多文章模式
   */
  get showArticleSelector(): boolean {
    return Object.keys(this.articleMap).length > 1;
  }

  /**
   * 当前登录用户
   */
  get currUser(): User | null {
    return (this.$store.state as RootState).currUser;
  }

  /** 是否显示纠错按钮 */
  get canSave(): boolean {
    return !this.savedArticle || !this.savedArticle.correct_text;
  }

  /** 是否显示“我要纠错”或“新建文章”按钮 */
  get showToCorrectBtn(): boolean {
    return this.actionType !== ActionType.create;
  }

  /** “我要纠错”或“新建文章”按钮文本 */
  get toCorrectBtnText(): string {
    return this.actionType === ActionType.example
      ? this.fromArticleId
        ? "返回编辑"
        : "我要纠错"
      : "新建文章";
  }

  /**
   * 编辑框上方的提示
   */
  get checkTips(): string {
    const longTextModelTips =
      (this.$store.state as RootState).appConfigs?.longTextModelTips || "";
    return this.canSave ? longTextModelTips : "";
  }

  /**
   * 是否把纠错按钮设置为不可点击状态
   */
  get disableCorrectBtn(): boolean {
    return (
      this.isLongTextModel &&
      this.calculateCountStatus !== CalculateStatus.success
    );
  }

  /**
   * 切换模式的按钮文本
   */
  get modelBtnText(): string {
    return this.isLongTextModel ? "返回普通模式" : "进入长文本模式";
  }

  /**
   * 编辑器下方文本长度、计算消耗的纠错次数和计算失败时的提示信息
   */
  get textLenTips(): CountResultTip {
    if (!this.canSave) return this.onlyTotalLenTipObj;
    if (this.isLongTextModel) {
      //计算纠错次数后，文本发生更改时
      if (this.isUpdateSinceCalculate) return this.calculateIngTipObj;
      //根据计算状态，显示对应的提示内容
      switch (this.calculateCountStatus) {
        case CalculateStatus.doing:
          return this.calculateIngTipObj;
        case CalculateStatus.fail:
          return this.calculateFailTipObj || this.defaultCalculateFailTipObj;
        case CalculateStatus.success:
          if (this.correctCountToPay > this.maxPayCountOnce)
            return this.overPayCountTipObj;
          else return this.normalPayCountTipObj;
      }
    } else {
      if (this.textLength > this.maxLenOnceCorrect)
        return this.overTextLenTipObj;
      else return this.normalTextLenTipObj;
    }
  }

  /**
   * 显示文本长度结果的提示style
   */
  get textLenTipsStyle(): object {
    return {
      display: "flex",
      "justify-content": "flex-end",
      margin: "10px 0px",
      cursor: this.isLongTextModel ? "pointer" : "auto",
      color: this.textLenTips.color,
    };
  }

  /**
   * 编辑器下方显示{@link failText}异常文本面板的标题
   */
  get failTextTitle(): string {
    const textLen = isEmpty(this.failText || "") ? 0 : this.failText?.length;
    return `错误位置(点击可在编辑器中选中对应文本(字数：${textLen}))`;
  }

  /**
   * 显示在右边的纠错信息
   */
  get correctInfos(): ICorrectInfo[] {
    if (!this.correctResults) return [];
    const infos: ICorrectInfo[] = [];
    this.correctResults.forEach((correctionsInLine, firstIndex) => {
      correctionsInLine.forEach((correction, secondIndex) => {
        if (!correction.show) return;
        const correctInfo: ICorrectInfo = {
          ...correction,
          firstIndex,
          secondIndex,
        };
        infos.push(correctInfo);
      });
    });
    return infos;
  }

  @Watch("isLongTextModel")
  onModelChange(isLongTextModel: boolean) {
    if (isLongTextModel) this.debouncePayCount();
    else this.debounceTextLength();
  }

  mounted() {
    logToConsole("check page params=", this.$route.params);
    //根据操作类型进行对应操作
    switch (this.actionType) {
      case ActionType.example: //范文
        const strId = (this.$route.params as PageParamsMap["example"])
          .fromArticleId;
        this.fromArticleId = strId ? parseInt(strId) : null;
        this.getDefaultArticle();
        break;
      case ActionType.edit: //查看文章
        // 获取路由参数中的操作类型和文章id
        const articleId = parseInt(
          (this.$route.params as PageParamsMap["acticle"]).id
        );
        if (this.isLogined && articleId) this.article(articleId);
        break;
    }
  }

  /**
   * 点击切换纠错模式按钮
   */
  clickModelBtn() {
    this.isLongTextModel = !this.isLongTextModel;
  }

  /**
   * 点击{@link failText}时调用
   */
  clickFailText() {
    if (!this.failText) return;
    const text = this.getText();
    logToConsole("clickFailText editor text=", text);
    if (isEmpty(text)) return;
    const failIndex = text.indexOf(this.failText);
    this.qEditor?.setSelection(failIndex, this.failText.length);
  }
  /**
   * 编辑器ready
   */
  onQEditorReady(editor: QuillEditor) {
    this.qEditor = editor;
    this.qEditor.clipboard.addMatcher(
      Node.ELEMENT_NODE,
      (node: any, delta: any) => {
        if (!this.matcherIsRun) return delta;
        logToConsole("delta", delta);
        let ops: any = [];
        delta.ops.forEach((op: any) => {
          if (op.insert && typeof op.insert === "string")
            ops.push({ insert: op.insert });
        });
        delta.ops = ops;
        return delta;
      }
    );
    this.qEditor.on(EventName.selectionChange, (range, oldRange, source) => {
      logToConsole("range", range);
      logToConsole("oldRange", oldRange);
      logToConsole("source", source);
    });
    this.qEditor.on(EventName.textChange, (delta, oldDelta, source) => {
      if (source == ChangeSource.user && this.hasCorrections()) {
        this.userDeltas.unshift(delta);
        logToConsole("userDeltas update newDelta = ", delta);
      }
      if (source == ChangeSource.user) this.failText = null;
      if (!this.canSave) return;
      this.debounceTextLength();
      if (this.isLongTextModel) this.debouncePayCount();
    });
  }

  /**
   * 点击纠错信息列表项时调用
   * @param firstIndex 点击的纠错信息对应在{@link correctResults}数组中的第一层的下标
   * @param secondIndex 点击的纠错信息对应在{@link correctResults}数组中的第而层的下标
   */
  clickCorrectItem(firstIndex: number, secondIndex: number) {
    logToConsole("clickCorrectItem firstIndex=", firstIndex);
    logToConsole("clickCorrectItem secondIndex=", secondIndex);
    const corrections = this.correctResults;
    if (!corrections[firstIndex] || !corrections[firstIndex][secondIndex]) {
      this.showNotFound(firstIndex);
      return;
    }
    //找出对应纠错信息
    const clickCorrection = corrections[firstIndex][secondIndex];
    this.qEditor?.setSelection(clickCorrection.indexTotal);
    logToConsole("clickCorrectItem correction=", clickCorrection);
    this.highLightCorrection(clickCorrection, firstIndex, secondIndex);
  }

  /**
   * 点击纠错信息列表项的替换词时调用
   * @param firstIndex 点击的纠错信息对应在{@link correctResults}数组中的第一层的下标
   * @param secondIndex 点击的纠错信息对应在{@link correctResults}数组中的第而层的下标
   */
  clickCorrectText(firstIndex: number, secondIndex: number) {
    const corrections = this.correctResults;
    if (!corrections[firstIndex][secondIndex]) return;
    //找出对应纠错信息
    const clickCorrection = corrections[firstIndex][secondIndex];
    this.qEditor?.setSelection(clickCorrection.indexTotal);
    //切割html段落
    this.updateAndRemarkHtml();
    const htmlLines = htmlTextSplitLines(this.correctHtml, true);
    const indexOffset = htmlStartWithWrap(this.correctHtml) ? 1 : 0;
    const lineIndex = (firstIndex + indexOffset) * 2;
    const htmlLine = htmlLines[lineIndex];
    //替换内容
    logToConsole("clickCorrectText before correction htmlLine=", htmlLine);
    const newHtmlLine = doCorrection(
      htmlLine,
      clickCorrection,
      correctionMarkId(firstIndex, secondIndex)
    );
    logToConsole("clickReplaceBtn after correction newHtmlLine=", newHtmlLine);
    if (newHtmlLine) htmlLines[lineIndex] = newHtmlLine;
    this.correctHtml = htmlLines.join("");
    //更新纠错信息，隐藏纠错item
    clickCorrection.show = false;
    this.correctResults = corrections;
    this.setQeditorHtml(this.correctHtml);
  }

  /**
   * 多篇文章的情况下，切换文章时调用
   */
  onArticleSelected(articleId: number) {
    logToConsole("检测界面 onArticleSelected articleId=", articleId);
    this.initArticleContent(this.articleMap[articleId]);
  }

  /**
   * 显示多篇文章模式下，设置文章列表
   */
  setArticleList(articles: IArticle[]) {
    logToConsole("检测界面 setArticleList articles=", articles);
    this.articleMap = {};
    let firstId: number | null = null;
    articles.forEach((article) => {
      if (!article.id) return;
      if (firstId === null) firstId = article.id;
      this.articleMap[article.id] = article;
    });
    if (firstId) this.onArticleSelected(firstId);
  }

  /**
   * 根据文章初始化当前界面
   */
  initArticleContent(savedArticle: IArticle) {
    this.currHighLight = null;
    this.savedArticle = savedArticle;
    this.currTitle = savedArticle.title || "";
    this.markCorrections(
      savedArticle.correction || [],
      savedArticle.content || ""
    );
  }

  /**
   * 获取并显示默认文章
   */
  async getDefaultArticle() {
    this.setArticleList(await ArticleApis.defaults());
  }

  /**
   * 获取并显示id为{@link articleId}的文章
   */
  async article(articleId: number) {
    this.setArticleList([await ArticleApis.query(articleId)]);
  }

  /**
   * 保存文章
   * @param is2Article 保存成功后是否路由到对应的文章界面
   */
  async save(is2Article: boolean = true) {
    if (this.showNotLogin()) throw "未登录";
    const currContent = this.parseCurrContent();
    if (this.showTitleContentEmpty(this.currTitle, currContent))
      throw "标题或内容为空";
    const articleId = this.savedArticle ? this.savedArticle.id : undefined;
    logToConsole("savedArticle", this.savedArticle);
    this.savedArticle = await ArticleApis.save({
      id: articleId,
      title: this.currTitle,
      content: currContent.html,
    });
    Message.success({
      message: "文章保存成功!",
      center: true,
      showClose: true,
    });
    if (is2Article && this.actionType === ActionType.create)
      this.route2Article(this.savedArticle.id!, true);
  }

  /**
   * 纠错
   */
  async check() {
    // 检查登录状态
    if (this.showNotLogin()) return;

    // 获取文章内容
    const currContent: Contents = this.parseCurrContent();
    logToConsole("check currContent=", currContent);

    // 检查文章内容是否合规
    if (this.showTitleContentEmpty(this.currTitle, currContent)) return;
    if (this.showTextLenLimit()) return;

    // 提示消耗和剩余的纠错次数
    if (!(await this.showCountConfirm())) {
      RouterTools.pushTo("pay");
      return;
    }

    this.correcting = true;

    // 纠错接口参数
    const params: CorrectParams = {
      articleId: this.savedArticle?.id,
      content: currContent.html,
      text: currContent.text,
      title: this.currTitle,
    };

    // 纠错请求
    try {
      const payCount = this.isLongTextModel ? this.correctCountToPay : 1;
      if (this.isLongTextModel) await this.longTextCorrect(params, payCount);
      else await this.shortTextCorrect(params, payCount);
    } catch (error: Response | any) {
      // 纠错失败
      this.showCorrectErr(error);
    }
  }

  /**
   * 发送非长文本纠错请求
   * @param params 请求参数
   * @param payCount 本次纠错消耗的纠错次数
   */
  async shortTextCorrect(params: CorrectParams, payCount: number) {
    const respData: CorrectRespData = await ArticleApis.correct(params, false);
    this.onCorrectSuccess(payCount, respData.article, respData.user);
  }

  /**
   * 发送长文本纠错请求并轮循查询结果
   * @param params 请求参数
   * @param payCount 本次纠错消耗的纠错次数
   */
  async longTextCorrect(params: CorrectParams, payCount: number) {
    const respData: LongCorrectRespData = await ArticleApis.longCorrect(
      params,
      false
    );
    setTimeout(() => {
      if (!respData.correction.id)
        throw "长文本纠错接口响应数据中的纠错记录id为空";
      this.queryCorrection(respData.correction.id, payCount);
    }, respData.minFinishTimeMS || 1000);
  }

  /**
   * 查询纠错记录
   * @param correctionId 纠错记录id
   * @param payCount 要查询的纠错记录id消耗了的纠错次数
   */
  async queryCorrection(correctionId: number, payCount: number) {
    try {
      const respData: CorrectionRespData = await ArticleApis.correction(
        correctionId
      );
      switch (respData.correction.status) {
        case CorrectStatus.notCorrect:
        case CorrectStatus.correcting:
          setTimeout(() => {
            this.queryCorrection(correctionId, payCount);
          }, 1000);
          break;
        case CorrectStatus.fail:
          this.showCorrectErr(
            Response.newForException(
              respData.correction.error_msg || Response.MSG_SERVER_EXCEPTION,
              `纠错记录状态为失败，纠错记录id为${correctionId}`
            )
          );
          break;
        case CorrectStatus.success:
          this.onCorrectSuccess(payCount, respData.article, respData.user);
          break;
      }
    } catch (error) {
      let errMsg =
        "纠错结果查询异常，可稍后前往“工作台”查看点击对应文章查看结果";
      if (error instanceof Response) errMsg += "，异常信息：" + error.userMsg;
      else logToServer("查询纠错结果时报错", error);
      this.$alert(errMsg, "纠错结果查询异常", { type: "error" });
    }
  }

  /**
   * 纠错成功时调用
   */
  onCorrectSuccess(payCount: number, article: IArticle, user: IUser) {
    this.correcting = false;
    this.savedArticle = article;
    let htmlContent = article.content;
    if (!htmlContent) {
      const currContent: Contents = this.parseCurrContent();
      htmlContent = currContent.html;
      logToServer("纠错成功后响应的文章html内容为空，文章id：" + article.id);
    }
    this.markCorrections(article.correction || [], htmlContent);
    Message.success("纠错成功");
    if (user) this.$store.commit(RootMutationNames.setCurrUser, user);
    this.route2Article(article.id!, true);
  }

  /**
   * 纠错请求发生错误时调用
   */
  showCorrectErr(error: Response | any) {
    this.correcting = false;
    const errIsResponse = error instanceof Response;
    let errResp: Response = errIsResponse
      ? error
      : Response.newForException(
          Response.MSG_APP_EXCEPTION,
          JSON.stringify(error)
        );
    if (!errIsResponse) logToServer(error);
    if (errIsResponse && error.code === Response.CODE_SENTENCE_TOO_LONG)
      this.showSentenceTooLong(error);
    else this.$alert(errResp.userMsg, "纠错失败", { type: "error" });
  }

  /**
   * 提示消耗和剩余的纠错次数，并确认是否继续纠错
   * @returns resolve参数为true时继续纠错，为false时前往充值界面，reject结果表示不继续，退出纠错操作
   */
  async showCountConfirm(): Promise<boolean> {
    if (!this.currUser) throw Error("确保currUser不为空再调用此方法");
    const aiFunCount = this.currUser.correctCount || 0;
    const testCount = this.currUser.correct_test_count || 0;
    if (aiFunCount === COUNT_NO_LIMIT) return true;
    const payCount = this.isLongTextModel ? this.correctCountToPay : 1;

    console.log("aiFunCount = ", aiFunCount);
    console.log("testCount = ", testCount);
    console.log("payCount = ", payCount);

    await this.$confirm(
      `${
        aiFunCount >= payCount
          ? `此操作将消耗${payCount}次AI功能次数，您当前拥有${aiFunCount}次，是否继续?`
          : aiFunCount + testCount >= payCount
          ? aiFunCount > 0
            ? `您当前剩余${aiFunCount}次AI功能次数，此操作将消耗完AI功能次数，并消耗${
                payCount - aiFunCount
              }次试用次数（当前拥有${testCount}次试用次数)，是否继续？`
            : `此操作将消耗${payCount}次试用次数，您当前拥有${testCount}次，是否继续？`
          : `您的AI功能次数不足，是否前往充值?`
      }`,
      "提示",
      {
        confirmButtonText: aiFunCount + testCount >= payCount ? "继续" : "前往",
        type: "warning",
      }
    );
    return aiFunCount + testCount >= payCount;
  }

  /**
   * 显示计算纠错次数失败的错误
   */
  showCountFailErr(response: Response) {
    if (response.code === Response.CODE_SENTENCE_TOO_LONG) {
      this.showSentenceTooLong(response);
      return;
    }
    this.calculateCountStatus = CalculateStatus.fail;
    const showRecalculate = response.code === Response.CODE_EXCEPTION;
    this.calculateFailTipObj = {
      text: `${this.totalTextLenMsg}，` + response.userMsg,
      color: appColors.dangerColor,
      showRecalculate: showRecalculate,
    };
  }

  /**
   * 显示纠错“句子太长”错误
   */
  showSentenceTooLong(response: Response) {
    if (response.code !== Response.CODE_SENTENCE_TOO_LONG) return;
    this.calculateCountStatus = CalculateStatus.fail;
    this.failText = response.data.failText;
    this.calculateFailTipObj = {
      text: `${this.totalTextLenMsg}，` + response.userMsg,
      color: appColors.dangerColor,
      showRecalculate: false,
    };
  }

  /**
   * 检查是否编辑器内容长度或消耗的纠错次数是否超过允许的最大值，如果超过则
   * 提示对应的错误信息
   * @returns 是否超过允许最大值
   */
  showTextLenLimit(): boolean {
    const msg = this.isLongTextModel
      ? this.correctCountToPay > this.maxPayCountOnce
        ? this.countLimitMsg
        : null
      : this.textLength > this.maxLenOnceCorrect
      ? this.lenLimitMsg
      : null;
    if (msg === null) return false;

    Message.error({
      message: msg,
      center: true,
      showClose: true,
    });
    return true;
  }

  /**
   * 检查当前用户是否已经登录，如未登录则显示“未登录”错误提示
   * @returns 是否是未登录
   */
  showNotLogin(): boolean {
    if (!this.isLogined) {
      Message.error({
        message: "未登录",
        center: true,
        showClose: true,
      });
      return true;
    }
    return false;
  }

  /**
   * 检查当前文章标题或内容是否为空，如果为空则则提示对应“不能为空”
   * 的错误提示
   * @returns 文章标题或内容是否为空
   */
  showTitleContentEmpty(currTitle: string, currContent: Contents): boolean {
    if (isEmpty(currTitle, true)) {
      Message.error({
        message: "标题不能为空",
        center: true,
        showClose: true,
      });
      return true;
    }
    if (isEmpty(currContent.html, true) || isEmpty(currContent.text, true)) {
      Message.error({
        message: "文章内容不能为空",
        center: true,
        showClose: true,
      });
      return true;
    }
    return false;
  }

  /**
   * debounce计算当前编辑器纯文本长度
   */
  debounceTextLength = debounce(this.calculateTextLength, 200);

  /**
   * 计算当前文本长度
   */
  calculateTextLength() {
    //计算文本长度
    this.isUpdateSinceCalculate = true;
    const currContent = this.parseCurrContent();
    this.textLength = currContent.text ? currContent.text.length - 1 : 0;
  }

  /**
   * debounce计算当前编辑器内容纠错时会消耗的纠错次数
   */
  debouncePayCount = debounce(this.calculatePayCount, 500);

  /**
   * 计算当前编辑器内容纠错时会消耗的纠错次数
   */
  async calculatePayCount() {
    if (!this.isLongTextModel) return;
    //计算文本消耗的纠错次数
    const currContent = this.parseCurrContent();
    this.failText = null;
    if (!currContent || isEmpty(currContent.text)) {
      this.isUpdateSinceCalculate = false;
      this.correctCountToPay = 0;
      this.calculateCountStatus = CalculateStatus.success;
    } else {
      this.calculateCountStatus = CalculateStatus.doing;
      try {
        const respData = await ArticleApis.countCorrect(
          currContent.text,
          false
        );
        if (typeof respData.count === "undefined")
          throw "计算纠错次数接口返回的count为undefind";
        this.correctCountToPay = respData.count;
        this.calculateCountStatus = CalculateStatus.success;
      } catch (error) {
        if (error instanceof Response) this.showCountFailErr(error);
        else {
          logToServer("计算纠错次数时异常", error);
          this.calculateCountStatus = CalculateStatus.fail;
          this.calculateFailTipObj = this.defaultCalculateFailTipObj;
        }
      }
      this.isUpdateSinceCalculate = false;
    }
  }

  /** 点击“返回编辑”、“我要纠错”或“新建文章”按钮时调用 */
  clickToCorrect() {
    if (this.fromArticleId) this.route2Article(this.fromArticleId);
    else RouterTools.pushTo("correct");
  }

  /** 点击“检测范例”按钮时调用 */
  async clickToExample() {
    // 如果需要，提醒用户是否保存文章
    try {
      await this.showConfirmSave();
      // 被保存文章的id
      const idSaved = this.savedArticle?.id;
      // 不保存，不需要保存或保存成功
      RouterTools.pushTo("example", {
        fromArticleId: idSaved ? idSaved + "" : undefined,
        afterSaved: "true",
      });
    } catch (error) {
      logError(error);
    }
  }

  /** 路由到”文章”页面 */
  route2Article(id: number | string, afterSaved?: boolean) {
    RouterTools.pushTo("acticle", {
      id: id + "",
      afterSaved: afterSaved ? "true" : undefined,
    });
  }

  /** 检查文章是否已被修改 */
  checkIsChanged() {
    // 文章不能保存情况，直接返回 false
    if (!this.canSave) return false;

    // 检查标题
    const titleIsChanged =
      this.actionType === ActionType.create
        ? !isEmpty(this.currTitle)
        : (this.savedArticle?.title || "") !== this.currTitle;
    if (titleIsChanged) return true;

    // 检查内容
    return this.actionType === ActionType.create
      ? !isEmpty(this.getText())
      : (this.savedArticle?.content || "") !== this.getCurrHtmlNoMark();
  }

  /**
   * 显示是否保存警告框
   * @returns 文章为被修改不需要保存或用户点击“不保存”返回
   * `fulfilled` 值 `false`，用户点击“保存”并保存成功返回 `fulfilled` 值
   * `true`，保存后的文章信息可通过 {@link savedArticle} 获取，
   * 关闭提示框取消离开返回 `rejected` 值 `close` 字符串，保存失败返回
   * `rejected` 值抛出的错误信息
   */
  async showConfirmSave(): Promise<boolean> {
    // 检查是否有修改内容
    const isChanged = this.checkIsChanged();

    // 没有修改
    if (!isChanged) return false;

    // 修改了提醒用户保存
    try {
      await this.$confirm(
        "内容已修改，是否保存？不保存修改的内容将会丢失?",
        "是否保存？",
        {
          confirmButtonText: "保存",
          cancelButtonText: "不保存",
          distinguishCancelAndClose: true,
        }
      );
      // 保存文章
      await this.save(false);
      // 保存成功
      return true;
    } catch (error) {
      // 点击不保存
      if (error === "cancel") return false;
      // 关闭提示框取消离开或保存失败
      else throw error;
    }
  }
}
